import React from 'react';

const variantStyles = {
    success: { background: '#ecfdf5', border: '1px solid #86efac', color: '#22c55e' },
    danger:  { background: '#fef2f2', border: '1px solid #fca5a5', color: '#ef4444' },
    default: { background: '#f9fafb', border: '1px solid #e5e7eb', color: '#111827' },
};

export default function SummaryCard({ label, value, variant = 'default', icon }) {
    const style = variantStyles[variant] ?? variantStyles.default;

    return (
        <div className="p-4 border-round shadow-1" style={{ background: style.background, border: style.border }}>
            <div style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: '0.5rem' }}>
                {icon && <i className={`${icon} mr-2`} style={{ color: style.color }} />}
                {label}
            </div>
            <div style={{ fontSize: '1.75rem', fontWeight: 'bold', color: style.color }}>
                {value ?? '—'}
            </div>
        </div>
    );
}
